import * as React from 'react';
import { ArrowBackOutlined, ArrowLeft, CloseOutlined } from '@mui/icons-material';
import { Grid, IconButton, Typography } from '@mui/material';
import { withRouter } from "react-router";
import { DEFAULT_INTERNAL_URL } from '../../constants/Constants';

const StyledSubHeader = ({
  title,
  history,
  location,
  closeIcon = false,
  hideButton = false,
  ...props
}) => {

  const handleBack = () => {
    /* const cameFromInternal = location.state && location.state.from;
    if (cameFromInternal) {
      history.goBack();
    } else {
      history.replace(DEFAULT_INTERNAL_URL);
    } */
    history.goBack();
  };

  return (
    <Grid
    container
    alignItems="center"
    spacing={2}
    sx={{ flexWrap: 'nowrap' }}
    {...props}
  >
   {!hideButton &&
   <Grid item>
     <IconButton
        onClick={handleBack}
        sx={{
          backgroundColor: 'white',
          width: 30,
          height: 30,
          borderRadius: '50%',
          boxShadow: 1,
          '&:hover': {
            backgroundColor: '#f0f0f0',
          },
        }}
      >
         {closeIcon ? <CloseOutlined sx={{ fontSize: '14px'}} /> : <ArrowLeft />}
      </IconButton>
    </Grid> 
    }
    <Grid item xs>
      <h6 style={{ margin: 0, overflowWrap: 'break-word', fontSize: '24px' }}>{title}</h6>
    </Grid>
  </Grid>
  );
};

export default withRouter(StyledSubHeader);